import { SortDirection } from '@mui/material';

export function flipSortDirection(direction: SortDirection, defaultDirection: SortDirection): SortDirection {
    if (direction === false) {
        return defaultDirection
    } else if (direction === 'asc') {
        return 'desc'
    }
    return 'asc'
}
